// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Card: {
    select: 'تحديد',
    titleLinkTooltip: 'الانتقال إلى الصفحة',
    collapseCardTooltip: 'طي البطاقة',
    expandCardTooltip: 'توسيع البطاقة'
  },
  CardList: {
    loadMore: 'تحميل المزيد',
    notFound: 'لم يُعثر على أي عناصر.',
    toolbarSelect: 'تحديد',
    viewCards: 'البطاقات',
    viewTiles: 'الإطارات المتجانبة',
    viewList: 'القائمة',
    toolbarView: 'العرض'
  },
  ClosingConfirmation: {
    confirm: 'المغادرة',
    cancel: 'العودة',
    content: 'هل تريد بالتأكيد إغلاق هذه النافذة ومغادرتها؟ لن تُحفظ أي تغييرات أجريتها على البيانات.'
  },
  Cuttable: {
    showMore: 'إظهار المزيد',
    showLess: 'إظهار أقل'
  },
  Dialog: {
    cancelButton: 'الإلغاء'
  },
  DrawerProgress: {
    cancelButton: 'الإلغاء'
  },
  Dropdown: {
    close: 'الإغلاق'
  },
  Form: {
    submitButton: 'الحفظ',
    applyButton: 'التطبيق',
    cancelButton: 'الإلغاء'
  },
  FormField: {
    clear: 'مسح التحديد',
    remove: 'الإزالة',
    addMore: 'إضافة حقل إدخال آخر'
  },
  FormFieldPassword: {
    improvePassword: 'لتحسين كلمة مرورك:',
    passwordTooShort: 'اجعل كلمة المرور أطول.',
    lettersLowerCase: 'استخدم حرفًا واحدًا صغيرًا على الأقل.',
    lettersUpperCase: 'استخدم حرفًا واحدًا كبيرًا على الأقل.',
    numbers1: 'استخدم رقمًا واحدًا على الأقل.',
    numbers3: 'استخدم ثلاثة أرقام على الأقل.',
    specialChar1: 'استخدم حرفًا خاصًا واحدًا على الأقل (على سبيل المثال: !، @، #، $، %، ^، &، *، ؟، _، ~).',
    specialChar2: 'استخدم حرفين خاصين على الأقل (على سبيل المثال: !، @، #، $، %، ^، &، *، ؟، _، ~).',
    comboUpperAndLower: 'استخدم كلاً من الأحرف الكبيرة والصغيرة.',
    comboLettersAndNumbers: 'استخدم كلاً من الأرقام والأحرف.',
    comboLettersNumbersSpecial: 'استخدم الأرقام والأحرف والأحرف الخاصة.',
    yourPasswordIsStrong: 'يمكنك جعلها أقوى عن طريق زيادة طولها.',
    passwordStrength: 'قوة كلمة المرور %%strength%%.',
    strengthVeryStrong: 'قوية جدًا',
    strengthStrong: 'قوية',
    strengthVeryWeak: 'ضعيفة جدًا',
    strengthWeak: 'ضعيفة',
    strengthMedium: 'متوسطة',
    hidePassword: 'إخفاء كلمة المرور',
    showPassword: 'إظهار كلمة المرور',
    generateButton: 'الإنشاء',
    copyButtonHint: 'نسخ كلمة المرور',
    copySuccessToast: 'تم نسخ كلمة المرور',
    generateButtonHint: 'إنشاء كلمة مرور قوية'
  },
  InPlaceEdit: {
    editButtonHint: 'تحرير القيمة',
    okButtonHint: 'حفظ التغييرات',
    cancelButtonHint: 'تجاهل التغييرات'
  },
  InputFile: {
    browseButton: 'اختيار ملف...'
  },
  List: {
    totalRows: '%%totalRows%% عناصر إجمالًا',
    selectedRows: 'تم تحديد %%selectedRows%% عناصر من أصل %%totalRows%%',
    all: 'الكل',
    allItemsOnPageSelected: 'تم تحديد جميع العناصر الموجودة في الصفحة',
    allItemsSelected: 'تم تحديد جميع العناصر',
    selectAllItems: 'تحديد جميع العناصر',
    selectAllItemsOnPage: 'تحديد جميع العناصر الموجودة في الصفحة',
    deselectAll: 'إلغاء التحديد'
  },
  ListEmptyView: {
    filteredTitle: 'تعذر العثور على أي عناصر مطابقة لعامل التصفية',
    emptyTitle: 'يبدو أنه لا يوجد شيء هنا',
    filteredDescription: 'عليك تحسين استعلامك أو إزالة بعض المعايير من عامل التصفية ثم المحاولة مرة أخرى.'
  },
  ListOperation: {
    cancelButton: 'الإلغاء'
  },
  Pagination: {
    totalShort: 'من %%total%%',
    itemsPerPage: 'عدد العناصر في كل صفحة',
    all: 'الكل',
    total: 'صفحة %%current%% من %%total%%'
  },
  ProgressDialog: {
    closeButton: 'الإغلاق',
    cancelButton: 'الإلغاء'
  },
  Select: {
    noOptions: 'لا توجد خيارات',
    placeholder: 'تحديد...'
  },
  SpotPopup: {
    total: '%%current%% من %%total%%'
  },
  Toaster: {
    closeGroup: 'إغلاق المجموعة'
  }
};